export const financialEntitiesList = [
  { key: 'BANCO_CAJA_SOCIAL', label: 'BANCO CAJA SOCIAL' },
  { key: 'BANCO_DAVIVIENDA', label: 'Davivienda' },
  { key: 'AVVILLAS', label: 'BANCO AV VILLAS' },
  { key: 'DAVIPLATA', label: 'Daviplata' },
  { key: 'BBVA', label: 'BBVA' },
  { key: 'RAPPIPAY', label: 'RappiPay' },
  { key: 'RAPPI_PRESTAMO', label: 'RappiPréstamo' },
  { key: 'LULO_BANK', label: 'Lulo Bank' },
  { key: 'PICHINCHA', label: 'Banco Pichincha' },
  { key: 'TUYA', label: 'Tuya' },
  { key: 'AFLORE', label: 'Aflore' },
  { key: 'AGUILA', label: 'Águila' },
  { key: 'CREAM_FINANCE', label: 'Creamfinance' },
  { key: 'VIVUS_PDL', label: 'Vivus' },
  { key: 'WENANCE', label: 'Wenance' },
  { key: 'CREDISSIMO', label: 'Credissimo' },
  { key: 'NUBANK', label: 'Nubank' },
  { key: 'MOVISTAR_MONEY', label: 'APEX' },
  { key: 'APEX', label: 'APEX' },
  { key: 'BANCO_DE_BOGOTA', label: 'Banco de Bogotá' },
  { key: 'SCOTIABANK', label: 'DAVIbank' },
  { key: 'OCCIDENTE', label: 'Banco de Occidente' },
  { key: 'BANCOLOMBIA', label: 'Bancolombia' },
  { key: 'AVVILLAS', label: 'AV Villas' },
  { key: 'ITAU', label: 'Itaú' },
  { key: 'NO_BANK', label: 'tu banco' },
  { key: 'CLARO', label: 'Claro' },

  { key: 'CFA_COOPERATIVA_FINANCIERA', label: 'CFA COOPERATIVA FINANCIERA' },
  { key: 'NEQUI', label: 'NEQUI' },
  { key: 'banco_davivienda', label: 'BANCO DAVIVIENDA' },
  { key: 'banco_de_bogota', label: 'BANCO DE BOGOTÁ' },
  { key: 'banco_popular', label: 'BANCO POPULAR' },
  { key: 'banco_itau_corpbanca_colombia', label: 'BANCO ITAU CORPBANCA COLOMBIA' },
  { key: 'bancolombia', label: 'BANCOLOMBIA' },
  { key: 'banco_citibank_colombia', label: 'BANCO CITIBANK COLOMBIA' },
  { key: 'banco_gnb_sudameris', label: 'BANCO GNB SUDAMERIS' },
  { key: 'bbva_colombia', label: 'BBVA COLOMBIA' },
  { key: 'red_multibanca_colpatria', label: 'DAVIbank' },
  { key: 'banco_de_occidente', label: 'BANCO DE OCCIDENTE' },
  { key: 'banco_caja_social', label: 'BANCO CAJA SOCIAL' },
  { key: 'banco_agrario_de_colombia', label: 'BANCO AGRARIO DE COLOMBIA' },
  { key: 'banco_av_villas', label: 'BANCO AV VILLAS' },
  { key: 'banco_procredit_colombia', label: 'BANCO PROCREDIT COLOMBIA' },
  { key: 'banco_pichincha', label: 'BANCO PICHINCHA' },
  { key: 'bancoomeva', label: 'BANCOOMEVA' },
  { key: 'banco_finandina', label: 'BANCO FINANDINA' },
  { key: 'banco_multibank', label: 'Banco Multibank S.A.' },
  { key: 'banco_santander', label: 'BANCO SANTANDER' },
  { key: 'banco_cooperativo_coopcentral', label: 'BANCO COOPERATIVO COOPCENTRAL' },
  { key: 'banco_compartir', label: 'BANCO COMPARTIR S.A.' },
  { key: 'financiera_juriscoop', label: 'FINANCIERA JURISCOOP' },
  { key: 'cooperativa_financiera_de_antioquia', label: 'COOPERATIVA FINANCIERA DE ANTIOQUIA' },
  { key: 'cooperativa_financiera_cotrafa', label: 'COOPERATIVA FINANCIERA COTRAFA' },
  { key: 'confiar', label: 'CONFIAR' },
  { key: 'serfinansa', label: 'Serfinansa' },
  { key: 'coltefinanciera', label: 'COLTEFINANCIERA' },
  { key: 'credifinanciera_credifinanciera', label: 'CREDIFINANCIERA S.A. CREDIFINANCIERA' },
  { key: 'bancamia', label: 'Bancamía S.A.' },
  { key: 'banco_w', label: 'BANCO W S.A.' },
  { key: 'mundo_mujer_el_banco_de_la_comunidad', label: 'MUNDO MUJER EL BANCO DE LA COMUNIDAD' },
  { key: 'banco_serfinanza', label: 'BANCO SERFINANZA' },
  { key: 'corficolombiana', label: 'Corficolombiana' },
  { key: 'jp_morgan', label: 'JP Morgan' },
  { key: 'bnp_paribas', label: 'BNP Paribas' },
  { key: 'corfi_gnb_sudameris', label: 'CORFI GNB SUDAMERIS' },
  { key: 'corporacion_financiera_davivienda', label: 'CORPORACIÓN FINANCIERA DAVIVIENDA S.A.' },
  { key: 'giros_y_finanzas', label: 'Giros y Finanzas' },
  { key: 'tuya', label: 'Tuya' },
  { key: 'leasing_bancoldex', label: 'Leasing Bancoldex' },
  { key: 'financiera_dann_regional', label: 'Financiera DANN Regional' },
  { key: 'pagos_internacionales', label: 'Pagos Internacionales' },
  { key: 'credifamilia', label: 'Credifamilia' },
  { key: 'crezcamos', label: 'CREZCAMOS' },
  { key: 'financiera_juriscoop_c_f.', label: 'FINANCIERA JURISCOOP C.F.' },
  { key: 'rci_colombia_compania_de_financiamiento', label: 'RCI COLOMBIA S.A. COMPAÑÍA DE FINANCIAMIENTO' },
  { key: 'skandia_old_mutual', label: 'SKANDIA - OLD MUTUAL' },
  { key: 'fiducoomeva', label: 'Fiducoomeva' },
  { key: 'santander_caceis', label: 'Santander Caceis' },
  { key: 'seguros_generales_sura', label: 'Seguros Generales SURA' },
  { key: 'seguros_de_vida_sura', label: 'Seguros De Vida SURA' },
  { key: 'bmi_colombia', label: 'BMI COLOMBIA' },
  { key: 'bancoldex', label: 'Bancoldex' },
  { key: 'findeter', label: 'Findeter' },
  { key: 'finagro', label: 'Finagro' },
  { key: 'icetex', label: 'Icetex' },
  { key: 'en_territorio', label: 'ENTerritorio' },
  { key: 'fogafin', label: 'Fogafin' },
  { key: 'fondo_nacional_del_ahorro', label: 'Fondo Nacional del Ahorro' },
  { key: 'fogacoop', label: 'Fogacoop' },
  { key: 'fondo_nacional_de_garantias', label: 'Fondo Nacional de Garantías' },
  { key: 'caja_de_vivienda_militar_y_de_policia', label: 'Caja de Vivienda Militar y de Polícia' },
  { key: 'jfk_cooperativa_financiera', label: 'JFK COOPERATIVA FINANCIERA' },
  { key: 'cooperativa_financiera_coofinep', label: 'Cooperativa Financiera Coofinep' },
  { key: 'ualet', label: 'UALET' },
  { key: 'mcca', label: 'MCCA' },
  { key: 'movii', label: 'MOVII S.A.' },
  { key: 'pgde', label: 'PGDE' },
  { key: 'tecnipagos', label: 'TECNIPAGOS' },
  { key: 'tarjeta_exito', label: 'Tarjeta Éxito' },
  { key: 'cooperativa_belen', label: 'Cooperativa Belén' },
  { key: 'refinancia', label: 'Refinancia' },
  { key: 'casa_cobro', label: 'Casa de cobro' },
  { key: 'other', label: 'Otro' },
];

export const getEntityLabel = (
  creditor: string,
  brand?: string | null,
) => {
  // Si es JCAP y el banco es SCOTIABANK, mostrar Colpatria
  if (brand === 'JCAP' && creditor === 'SCOTIABANK') {
    return 'Colpatria';
  }
  return financialEntitiesList.find(({ key }) => key === creditor)?.label || creditor;
};

export const financialEntitiesOptions = financialEntitiesList
  .sort((a, b) => (a.key === 'other' ? Infinity : a.label.localeCompare(b.label)))
  .map(({ key, label }) => ({ value: key, label }));
